import {
  Calendar,
  MessageSquare
} from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../redux/store';
import { chatSelectOneObjectByQuery } from '../../../redux/thunks/DBServiceThunks';
import { getLanguageDirection } from '../../../i18n/config';
import LanguageSwitcher from '../../common/LanguageSwitcher';
import { Card } from '../../ui/card';

/**
 * Chat header component
 */
const ChatHeader: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isRTL = getLanguageDirection(i18n.language) === 'rtl';

  const currentChatId = useAppSelector(state => state.ChatReducer.currentChatId);
  const currentChat = useAppSelector(state => chatSelectOneObjectByQuery(state.DBChatReducer, { _id: currentChatId }));

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  };

  return (
    <Card
      dir={getLanguageDirection(i18n.language)}
      className="flex items-center justify-between px-6 py-5 border-b border-border/70 bg-background/80 backdrop-blur-sm sticky top-0 z-10 rounded-none shadow-sm min-h-[88px]"
      style={{ height: '91px' }}
    >
      {/* Chat info */}
      <div className="flex items-center flex-1">
        <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-gold/12 border border-gold/26 me-3">
          <MessageSquare
            size={20}
            strokeWidth={1.5}
            className="text-gold"
          />
        </div>

        <div>
          <h2 className="text-lg font-semibold text-foreground text-start">
            {currentChat?.title || t('common.assistant.nameWithRole', { name: t('components.sidebar.brandName') })}
          </h2>

          {currentChat && (
            <div className="flex items-center gap-1 mt-1">
              <Calendar size={14} className="text-muted-foreground" />
              <span className="text-xs text-muted-foreground">
                {formatDate(currentChat.updatedAt)}
              </span>
            </div>
          )}
        </div>
      </div>

      {/* Language Switcher */}
      <div className="flex items-center opacity-85 hover:opacity-100 transition-opacity ms-4">
        <LanguageSwitcher variant="compact" showLabel={false} />
      </div>
    </Card>
  );
};

export default ChatHeader;
